/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Map_TitleInputs */

const en_us2_exercise_sheet_map_title = /** @type {(inputs: Exercise_Sheet_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscle map`)
};

const pt_br2_exercise_sheet_map_title = /** @type {(inputs: Exercise_Sheet_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa muscular`)
};

const es_419_exercise_sheet_map_title = /** @type {(inputs: Exercise_Sheet_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa muscular`)
};

const pt_pt2_exercise_sheet_map_title = /** @type {(inputs: Exercise_Sheet_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa muscular`)
};

const fr_fr2_exercise_sheet_map_title = /** @type {(inputs: Exercise_Sheet_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte musculaire`)
};

const de_de2_exercise_sheet_map_title = /** @type {(inputs: Exercise_Sheet_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muskelkarte`)
};

const it_it2_exercise_sheet_map_title = /** @type {(inputs: Exercise_Sheet_Map_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mappa muscolare`)
};

/**
* | output |
* | --- |
* | "Muscle map" |
*
* @param {Exercise_Sheet_Map_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_map_title = /** @type {((inputs?: Exercise_Sheet_Map_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Map_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_map_title(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_map_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_map_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_map_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_map_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_map_title(inputs)
	return en_us2_exercise_sheet_map_title(inputs)
});
export { exercise_sheet_map_title as "exercise-sheet.map_title" }